import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const submitDefaultAddressActions = createDataModuleActions(
    'SUBMIT_DEFAULT_ADDRESS',
);
export const submitDefaultAddress = submitDefaultAddressActions.dataRequest;
export const submitDefaultAddressSuccess =
    submitDefaultAddressActions.dataSuccess;
export const submitDefaultAddressError = submitDefaultAddressActions.dataError;
export const submitDefaultAddressReset = submitDefaultAddressActions.dataReset;
